import React from 'react';
import { MessageSquare, Check, AlertCircle, Clock } from 'lucide-react';
import './sms-activity.css';

export const smsEvents = entry => Object.values(entry?.sms_activity || {}).sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)));
const labels = { accepted: 'Accepted by GHL', failed: 'Failed', unknown: 'Outcome unknown', skipped: 'Skipped',
  processing: 'Preparing', submitting: 'Submitting', delivered: 'Delivered' };

export const SmsActivity = ({ entry, compact = false, testId = 'sms-activity' }) => {
  const events = smsEvents(entry);
  const webhook = entry?.post_call_webhook_delivery;
  if (!events.length && !webhook) return null;
  return <div className={`sms-activity ${compact ? 'sms-activity-compact' : ''}`} data-testid={testId}>
    {webhook && <div className="sms-event" data-testid={`${testId}-webhook`}>
      <div className="sms-event-line"><Clock size={12} />Post-call webhook · {webhook.status === 'accepted' ? 'Workflow accepted' : 'Failed'}</div>
      {!compact && <p className="sms-event-reason">{webhook.reason}{webhook.http_status ? ` (HTTP ${webhook.http_status})` : ''}</p>}
    </div>}
    {events.map(event => {
      const Icon = event.status === 'accepted' || event.status === 'delivered' ? Check :
        ['failed', 'unknown'].includes(event.status) ? AlertCircle : Clock;
      return <div key={event.attempt_id} className={`sms-event sms-event-${event.status}`} data-testid={`${testId}-${event.attempt_id}`}>
        <div className="sms-event-line">
          <MessageSquare size={13} aria-hidden="true" />
          <span>{event.source === 'post_call' ? 'Post-call SMS' : 'Send SMS'}</span>
          <span className="sms-event-status" data-testid={`${testId}-${event.attempt_id}-status`}><Icon size={12} />{labels[event.status] || event.status}</span>
        </div>
        {event.sms_option_name && <p data-testid={`${testId}-${event.attempt_id}-option`} className="text-xs font-medium mt-1 break-words [overflow-wrap:anywhere]">{event.sms_option_name}</p>}
        {!compact && <>
          <p className="sms-event-reason" data-testid={`${testId}-${event.attempt_id}-reason`}>{event.reason}</p>
          <div className="sms-event-meta" data-testid={`${testId}-${event.attempt_id}-metadata`}>
            {event.timestamp && <span>{new Date(event.timestamp).toLocaleString()}</span>}
            {event.recipient && <span>To {event.recipient}</span>}
            {event.message_id && <span>GHL message: <code>{event.message_id}</code></span>}
          </div>
        </>}
      </div>;
    })}
  </div>;
};